/** QL-375 — the mandate basis table (screen 01). Read with `useT(T)`. */
export const T = {
  en_GB: {
    // Basis table
    colPortfolio: "Portfolio",
    colTypeSchedule: "Type and schedule",
    colProjected: "Projected, end of year 1",
    colShare: "Share of basis",
    combined: "Combined basis",
    year1Hint: (date: string) => `${date}, one year after the first deposit`,
    oneTime: "One-time",
    recurring: "Recurring",
    followup: "Follow-up",
    typeModel: "Model",
    typeCustom: "Custom",
    typeDynamic: "Dynamic",
    perMonth: "/ month",
    perQuarter: "/ quarter",
    perYear: "/ year",
    // Not checked
    basisBuy: "new money only",
  },
  nb_NO: {
    colPortfolio: "Portefølje",
    colTypeSchedule: "Type og plan",
    colProjected: "Forventet, utgangen av år 1",
    colShare: "Andel av grunnlaget",
    combined: "Samlet grunnlag",
    year1Hint: (date: string) => `${date}, ett år etter første innskudd`,
    oneTime: "Engangs",
    recurring: "Løpende",
    followup: "Oppfølging",
    typeModel: "Modell",
    typeCustom: "Egendefinert",
    typeDynamic: "Dynamisk",
    perMonth: "/ måned",
    perQuarter: "/ kvartal",
    perYear: "/ år",
    basisBuy: "kun nye penger",
  },
} as const;
